import PropTypes from 'prop-types';

import { Dialog, Button } from '@ctct/ui-react';

const DuplicateConfirmation = ({ t, email, onOk, onCancel }) => {
  return (
    <Dialog
      isOpen
      heading={t('duplicate_confirmation.heading')}
      data-qe-id="duplicate-confirmation-dialog"
      footerActions={
        <>
          <Button
            text={t('duplicate_confirmation.cancel')}
            onClick={onCancel}
            data-qe-id="duplicate-confirmation-cancel"
          />
          <Button
            text={t('duplicate_confirmation.ok')}
            kind="primary"
            onClick={onOk}
            data-qe-id="duplicate-confirmation-continue"
          />
        </>
      }
    >
      {t('duplicate_confirmation.text', { email })}
    </Dialog>
  );
};

DuplicateConfirmation.propTypes = {
  t: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
};

DuplicateConfirmation.defaultProps = {};

export default DuplicateConfirmation;

export { DuplicateConfirmation };
